export default class TabsContent {
    constructor() {
        this.sections = document.querySelectorAll('.block-tabs-content');
        if (this.sections.length > 0) {
            this.init();
        }
    }

    init() {
        this.sections.forEach(section => {
            this.buildTabs(section);
        });
    }

    // --- TABS DE CATEGORIA
    buildTabs(section) {
        const tabsContainer = section.querySelector('.nav-tabs-content-tabs');
        const select = section.querySelector('.tabs-content-select'); // mobile
        const categories = section.querySelectorAll('.block-tabs-content-item');
        if ((!tabsContainer && !select) || categories.length === 0) return;

        categories.forEach((cat, index) => {
            const title = cat.dataset.title || `Categoria ${index + 1}`;
            const icon = cat.dataset.icon || ``;
            const iconHover = cat.dataset.iconhover || ``;

            // --- Botão desktop ---
            if (tabsContainer) {
                const btn = document.createElement('button');
                btn.className =
                    "item-tab group flex flex-row gap-2 items-center whitespace-nowrap font-extrabold font-montserrat text-xl/150 py-[46.5px] px-8 text-left relative before:absolute before:w-0 before:h-full before:content-[''] before:right-0 before:bg-primary before:bottom-0 hover:before:w-[0.1875rem] transition-all border-none text-darkest [&.active]:before:w-[0.1875rem] [&.active]:bg-lightf4 [&.active]:text-primary";
                
                // conteúdo com ícones + título
                btn.innerHTML = `
                    ${icon ? `
                        <span class="relative w-5 h-5">
                            <img src="${icon}" alt="${title}" class="absolute inset-0 w-5 h-5 object-contain block group-hover:hidden group-[.active]:hidden">
                            ${iconHover ? `<img src="${iconHover}" alt="${title}" class="absolute inset-0 w-5 h-5 object-contain hidden group-hover:block group-[.active]:block">` : ''}
                        </span>
                    ` : ''}
                    <span>${title}</span>
                `;

                btn.dataset.index = index;
                btn.addEventListener('click', () => this.activateTab(section, index));
                tabsContainer.appendChild(btn);
            }

            // --- Option mobile ---
            if (select) {
                const option = document.createElement('option');
                option.value = index;
                option.text = title;
                select.appendChild(option);
            }
        });

        // ativa a primeira por padrão
        this.activateTab(section, 0);

        // evento mobile
        if (select) {
            select.addEventListener('change', e => {
                const idx = parseInt(e.target.value);
                this.activateTab(section, idx);
            });
        }
    }


    activateTab(section, index) {
        const tabs = section.querySelectorAll('.item-tab'); // ✅ botões individuais
        const categories = section.querySelectorAll('.block-tabs-content-item');

        // reset
        tabs.forEach(tab => tab.classList.remove('active'));
        categories.forEach(cat => cat.classList.add('hidden'));

        // ativa
        const activeTab = tabs[index];
        const activeCat = categories[index];
        if (activeTab && activeCat) {
            activeTab.classList.add('active');
            activeCat.classList.remove('hidden');
        }
    }

}

if (document.querySelector('.block-tabs-content')) {
    new TabsContent();
}
